export { default as useEventListener } from './useEventListener';
export * from './useEventListener';
//# sourceMappingURL=index.js.map